<template>
  <div class="flex flex-col lg:flex-row lg:justify-between gap-y-10 gap-x-7">
    <FooterLinkColumn
      :title="$t('Customer service')"
      :links="footerLinks.CUSTOMER_SERVICE"
      class="flex-1"
    >
      <template #top>
        <div class="mb-4 lg:mb-10 flex flex-col gap-4">
          <CustomButton
            v-if="shouldShowWebform"
            type="quaternary"
            data-gtm="footer-contact-us-button"
            @click="openContactForm"
          >
            {{ $t('Contact us') }}
          </CustomButton>
          <CustomButton
            :url="returnPortalUrl"
            type="secondary"
            data-gtm="footer-return-portal-button"
          >
            {{ $t('Returns portal') }}
          </CustomButton>
          <CustomButton
            type="senary"
            data-gtm="footer-withdraw-contract-button"
            @click="openWithdrawContractForm"
          >
            {{ $t('Withdraw contract') }}
          </CustomButton>
          <ContactInformation />
        </div>
      </template>
      <template #bottom>
        <RenderContent
          v-if="trustedPaymentsContent.length"
          :content="trustedPaymentsContent"
        />
      </template>
    </FooterLinkColumn>
    <FooterLinkColumn
      :title="$t('About us')"
      :links="footerLinks.ABOUT_US"
      class="flex-1"
    >
      <template #bottom>
        <SocialLinks />
      </template>
    </FooterLinkColumn>
    <div class="flex flex-col flex-1 gap-8">
      <FooterLinkColumn
        :title="$t('Our products')"
        :links="footerLinks.OUR_PRODUCTS"
      />
      <FooterLinkColumn
        :title="$t('Our brands')"
        :links="footerLinks.FOOTER_BRANDS"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { PropType } from 'vue';
import type { ComponentData } from '~~/types/cms/CmsComponentData';
import RenderContent from '~/cms/RenderContent.vue';

import { RETURN_PORTAL_URL } from '~~/constants/checkout';

export default defineComponent({
  name: 'FooterLinkColumns',
  components: {
    RenderContent,
  },

  props: {
    shouldShowWebform: {
      type: Boolean,
      default: false,
    },
    footerLinks: {
      type: Object,
      default: () => ({}),
    },
    trustedPaymentsContent: {
      type: Array as PropType<ComponentData[]>,
      default: () => [],
    },
  },
  emits: ['openContactForm'],
  setup(_, { emit }) {

    const { openWebformModal } = useWebformModalStore();

    const openContactForm = (): void => {

      emit('openContactForm');

    };

    const openWithdrawContractForm = (): void => {

      openWebformModal({ shouldOpenOrderCancellationForm: true });

    };

    return {
      returnPortalUrl: RETURN_PORTAL_URL,
      openContactForm,
      openWithdrawContractForm,
    };

  },
});

</script>
